import React from 'react';
import Image from 'next/image';
import { LandingPageConfig } from 'src/generated/landing-page-config-schemas/v1/type';
import { Box, Typography } from '@mui/material';

type Props = Extract<
  LandingPageConfig['data']['slices'][number],
  { type: 'about' }
> & {
  backgroundColor: string;
};

const About: React.FC<Props> = (props) => {
  const { title, text, image, backgroundColor } = props;

  return (
    <Box
      sx={{
        py: { xs: 4, md: 12 },
        px: { xs: 4, md: 0 },
        backgroundColor,
      }}
    >
      <Box sx={{ maxWidth: '1312px', margin: '0 auto', px: 2 }}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            textAlign: { xs: 'left', md: 'center' },
            gap: 6,
          }}
        >
          {/* Title */}
          <Box>
            <Typography
              variant="h2"
              sx={{
                fontSize: { xs: '32px', md: '48px' },
                fontWeight: 600,
                mb: 3,
              }}
            >
              {title}
            </Typography>

            <Typography
              variant="body1"
              sx={{
                color: '#737373',
                mx: 'auto',
                maxWidth: '700px',
                whiteSpace: 'pre-line',
              }}
            >
              {text}
            </Typography>
          </Box>

          {/* Image Section */}
          {image && image.url && (
            <Box
              sx={{
                width: '100%',
                maxWidth: '900px',
                borderRadius: 2,
                overflow: 'hidden',
              }}
            >
              <Image
                src={image.url}
                alt="An image showcasing our meal subscription service"
                width={900}
                height={506}
                sizes="(max-width: 900px) 100vw, 900px"
                style={{ width: '100%', height: 'auto', display: 'block' }}
              />
            </Box>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default About;
